import locale from "csi/locale";
import reflection from "csi/reflection";
import xml from "csi/xml";
import { C8Node } from "src/c8-platform/type/node";

/** Determine the suggested save nodes for snapshots in the 3D Viewer */
export function getSnapshotSuggestedNodes(rootNode: C8Node, colorways: C8Node[], document: C8Node, locationType: string): string[] {
	const suggestedNodes = [];
	const defaultStyle3DViewable = rootNode.StyleDefault3DViewable;
	const defaultMaterial3DViewable = rootNode.Default3DMaterial;
	const docUrl = document.$URL;

	// If the root node is a style, then suggest the style
	if (locationType === "Document"){
		if (defaultStyle3DViewable === docUrl) {
			suggestedNodes.push(locale.type("Style"));
			if (document.DocumentColors.length > 0) {
				suggestedNodes.push(locale.typePlural("Colorway"));
			}
		} else if (defaultMaterial3DViewable === docUrl) {
			suggestedNodes.push(locale.type("Material"));
		} else if (document.DocumentColors.length > 0) {
			suggestedNodes.push(locale.typePlural("Colorway"));
		} else {
			suggestedNodes.push(locale.type("DocumentRevision"));
		}
	} else if (rootNode.$Type === "Style") {
		suggestedNodes.push(locale.type("Style"));
		if (colorways?.some((colorway) => colorway.ColorDefault3DViewable === docUrl)) {
			suggestedNodes.push(locale.typePlural("Colorway"));
		}
	} else if (rootNode.$Type === "Material") {
		suggestedNodes.push(locale.type("Material"));
	}

	return suggestedNodes;
}

/** Filter nodes that the user does not have write access to the image attribute */
export function filterSnapshotSaveNodes(nodes: C8Node[]): C8Node[] {
	return nodes.filter((node) => {
		return xml.nodeHasAccess(node, xml.RIGHT_WRITE, reflection.ATTR_IMAGES);
	});
}